
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 490 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M328 88h-32l-11.056-22.112A75.777 75.777 0 00217.167 24h-50.334a75.777 75.777 0 00-67.777 41.888L88 88H56a32 32 0 00-32 32v336a32 32 0 0032 32h272a32 32 0 0032-32V120a32 32 0 00-32-32zm-88-16a16 16 0 01-16 16h-64a16 16 0 01-16-16 16 16 0 0116-16h64a16 16 0 0116 16z","fill":"#dedede"}}),_c('path',{attrs:{"d":"M72 488V168a32 32 0 0132-32h176a32 32 0 0132 32v320zM416 488a24 24 0 01-24-24V360h48v104a24 24 0 01-24 24z","fill":"#d0d0d0"}}),_c('path',{attrs:{"d":"M392 360V24a360 360 0 0172 216v72l-24 16v32z","fill":"#e5e7e9"}}),_c('circle',{attrs:{"cx":"416","cy":"456","fill":"#a7a7a7","r":"8"}})])
          )
        }
      }
    